module.exports = __webpack_public_path__ + "static/media/vector.b6420ad7.svg";